import { useEffect, useState } from 'react';
import { useCompanyStore } from '../stores/company';

// Browser-local KMS mock to avoid bundling backend code
type Entry = { ts:string; companyId:string; action:string; keyId:string };
const LS_KEY = 'evat:kms';
function load(): { keys:Record<string,string>; log:Entry[] } {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return { keys: {}, log: [] };
    return JSON.parse(raw) as { keys:Record<string,string>; log:Entry[] };
  } catch {
    return { keys: {}, log: [] };
  }
}
function save(db:{ keys:Record<string,string>; log:Entry[] }) {
  try { localStorage.setItem(LS_KEY, JSON.stringify(db)); } catch {}
}
function custodyLog(): Entry[] { return load().log.slice(-100).reverse(); }
function generateKey(companyId:string){
  const db = load();
  const keyId = `kms-${companyId}-${Math.random().toString(36).slice(2,8)}`;
  db.keys[companyId] = keyId;
  db.log.push({ ts:new Date().toISOString(), companyId, action:'generateKey', keyId });
  save(db);
  return { keyId };
}
function rotateKey(companyId:string){
  const db = load();
  const keyId = `kms-${companyId}-${Math.random().toString(36).slice(2,8)}`;
  db.keys[companyId] = keyId;
  db.log.push({ ts:new Date().toISOString(), companyId, action:'rotateKey', keyId });
  save(db);
  return { keyId };
}
function sign(companyId:string, keyId:string, _payload:any){
  const db = load();
  const sig = btoa(`${keyId}:${Date.now()}`).slice(0,32);
  db.log.push({ ts:new Date().toISOString(), companyId, action:'sign', keyId });
  save(db);
  return sig;
}

function KMSManager() {
  const company = useCompanyStore((s)=> s.companies.find(c=>c.id===s.activeId) ?? null);
  const [keyId, setKeyId] = useState('');
  const [logs, setLogs] = useState<any[]>([]);
  useEffect(()=>{ setLogs(custodyLog()); },[]);
  const gen = () => { if (!company) return; const r = generateKey(company.id); setKeyId(r.keyId); setLogs(custodyLog()); };
  const rot = () => { if (!company) return; const r = rotateKey(company.id); setKeyId(r.keyId); setLogs(custodyLog()); };
  const testSign = () => { if (!company||!keyId) return; const sig = sign(company.id, keyId, { ping:'pong' }); alert(sig.slice(0,16)+'...'); setLogs(custodyLog()); };
  return (
    <div className="space-y-3">
      <div className="font-orbitron text-evat-gold">KMS/HSM Manager</div>
      <div className="flex gap-2 text-sm">
        <button onClick={gen} className="px-3 py-1 rounded border border-evat-neon text-evat-neon">Generate</button>
        <button onClick={rot} className="px-3 py-1 rounded border border-evat-gold text-evat-gold">Rotate</button>
        <button onClick={testSign} className="px-3 py-1 rounded border border-evat-neon text-evat-neon">Test Sign</button>
        <div className="text-xs text-neutral-400">Active key: {keyId || '-'}</div>
      </div>
      <div className="border border-neutral-700 rounded p-2 text-xs max-h-64 overflow-auto">
        {logs.map((l,i)=> (<div key={i} className="flex justify-between"><span>{l.ts}</span><span>{l.companyId}</span><span>{l.action}</span><span>{l.keyId}</span></div>))}
        {logs.length===0 && <div className="text-neutral-500">No custody entries</div>}
      </div>
    </div>
  );
}

export default KMSManager;



